import {useIsRealUserModeEnabled} from '@aboutyou/data-fetcher';
import {lazy} from '@aboutyou/lazy-imports';
import {FooterSkeleton} from '@aboutyou/logic-components';
import {useCurrentPageType} from '@aboutyou/router';
import {useInView} from '@aboutyou/ui-components';
import React, {FC, memo} from 'react';

const LazyFooterDynamic = lazy(
  () =>
    import('@aboutyou/logic-components').then(mod => ({
      default: mod.FooterDynamic,
    })),
  {fallback: <FooterSkeleton />},
);

const FooterConfigured: FC = memo(function Footer() {
  // memo is used as the useCurrentPageType is expensive and should not trigger too often
  const isCheckout = useCurrentPageType() === 'checkout';

  return <LazyFooterDynamic hideCategories={isCheckout} />;
});

export const FooterDynamic = () => {
  const isRealUserModeEnabled = useIsRealUserModeEnabled();
  const {ref, inView} = useInView<HTMLDivElement>({
    threshold: 0,
    rootMargin: '500px',
    triggerOnce: true,
  });

  if (!isRealUserModeEnabled) {
    // if real user mode is not activated, always render the footer on the server
    return <FooterConfigured />;
  }

  return inView ? <FooterConfigured /> : <FooterSkeleton ref={ref} />;
};
